import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// import { addProducttoCart } from '../../../../../Redux/Actions/EndUser/StoreActions';
import { auth } from '../../../../../services';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { store } from '../../../../../services/store.service';
import { getCartItems, addtoCart } from '../../../../../Redux/Actions/EndUser/StoreActions';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class StoreProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Quantity: 1,
            SizeId: this.props.product.sizes && this.props.product.hasSize ? (this.props.product.sizes.length != 0?  this.props.product.sizes[0].sizeOptionId : null) : null,
            ColorId: this.props.product.colors && this.props.product.hasColor ? (this.props.product.colors.length != 0? this.props.product.colors[0].colorOptionId : null) : null,
            UserId: null,
            ProductId: this.props.product.productId,
            ProductName: this.props.product.title,
            Cost: this.props.product.price,
            Discount: this.props.product.discount,
            Color: this.props.product.colors && this.props.product.hasColor ? (this.props.product.colors.length != 0 ? this.props.product.colors[0].description : "") : "",
            Size: this.props.product.sizes && this.props.product.hasSize ? (this.props.product.sizes.length != 0? this.props.product.sizes[0].description : "") : "",
            Image: "",
            isModalOpen: false,
            ImageUrl: this.props.product.image && this.props.product.image.url ? this.props.product.image.url : ""
        }
    }

    componentDidMount() {
        var userId = auth.getAuthUserId();
        this.setState({
            UserId: userId,
        });
        this.props.getCartItems();
    }

    colorChange = (event) => {
        let target = event.target;
        const value = target.value;
        this.setState({
            ColorId: value.colorOptionId,
            Color: value.description
        });
    }

    priceChange = (event) => {
        let target = event.target;
        const value = target.value;
        this.setState({
            SizeId: value.sizeOptionId,
            Size: value.description
        });
    }

    handleChange = ({ target }) => {

        if (target.type == 'number') {
            
            if (target.name == "Quantity") {

                if (target.valueAsNumber < 1) {
                    target.valueAsNumber = 1;
                } else if (target.valueAsNumber > 99) {
                    target.valueAsNumber = 99
                }
            }
        }

        this.setState({ [target.name]: target.valueAsNumber });
    };

    addtoCart =(base64, product) => {
        console.log(this.state, "state")
        this.setState({
            Image:base64
        },()=>{
            this.props.addtoCart(this.state, this.props.cartItems)
        })
        this.toggleModal();
    }

    toggleModal = () => {
        let isOpen = this.state.isModalOpen ? false : true;
        this.setState({
            isModalOpen: isOpen
        });
    }

    render() {
        return (
          <div className="storeCard row">
              <div className="col-lg-4 d-flex flex-column p-0">
                  <div className="header">
                  {
                      this.props.product.image != null && this.props.product.image.url ?
                        <img src={this.props.product.image.url} className="defaultImgHeight" /> :
                        <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                  }
                  </div>
              </div>
              <div className="col-lg-3  d-flex flex-column justify-content-start align-items-center align-items-lg-start pl-lg-3">
                  <h4 className="productTitle">{this.props.product.title}</h4>
                  {this.props.product.discount !=null?
                    <div className="styleDiscountPricing">
                        <span className="productPrice"><strike>${this.props.product.price}</strike></span>
                        <span className="productPrice padLeft">${this.props.product.discount}</span>
                    </div>
                    :
                    <div className="styleDiscountPricing">
                        <p className="productPrice">
                            ${this.props.product.price}
                        </p>
                    </div>
                  }
                  <div>{this.props.product.productDescription}</div>
              </div>
              <div className="col-lg-3 d-flex flex-column justify-content-start align-items-center pt-3 pt-lg-3">
                  {(this.props.product.hasColor && this.props.product.colors.length != 0)?
                    <div className="product-wrapper">
                        {/* <p className="product-text">Color</p> */}
                        <span className="product-dropdown">
                                    <DropDownList
                                      defaultItem={ this.props.product.colors[0] || ''}
                                      data={this.props.product.colors}
                                      onChange={this.colorChange}
                                      textField="description"
                                      dataItemKey="colorOptionId"
                                    />
                                </span>
                    </div>
                    :""
                  }
                  {(this.props.product.hasSize && this.props.product.sizes.length != 0)?
                    <div className="product-wrapper">
                        {/* <p className="product-text">Size</p> */}
                        <span className="product-dropdown">
                                    <DropDownList
                                      defaultItem={this.props.product.sizes[0] || ''}
                                      data={this.props.product.sizes}
                                      onChange={this.priceChange}
                                      textField="description"
                                      dataItemKey="sizeOptionId"
                                      allowCustom={true}
                                    />
                                </span>
                    </div>
                    :""
                  }
                  <div className="quantityInput">
                      <span>Quantity</span>
                      <input name="Quantity" onChange={this.handleChange} value={this.state.Quantity} type='number' min="1" max="99" />
                  </div>
              </div>
              <div className="col-lg-2 d-flex flex-column justify-content-start align-items-center align-items-lg-start  pt-3 pt-lg-3">
                  <button className="addToCartBtn" onClick={() => this.addtoCart(this.props.product.image.base64, this.props.product)}>Add To Cart</button>
              </div>
              <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal} className={this.props.className}>
                  <ModalHeader toggle={this.toggleModal}>Product added</ModalHeader>
                  <ModalBody>
                      <div>{this.state.ProductName} was successfully added to cart</div>
                  </ModalBody>
              </Modal>
          </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        cartItems: state.store.cartItems,
        cartTotal: state.store.cartTotal
    }
}

export default withRouter(connect(mapStateToProps, { getCartItems,addtoCart })(StoreProduct));
